import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

import { LegalService } from '../../../core/api/legal-page.service';
import { LegalPage } from '../../../shared/models';
import { selectAdminFiltersAndPage } from '../../../store/admin/admin.selectors';
import * as fromApp from '../../../store/index';
import { AdminTableBase } from '../admin-table-base/admin-table-base';

@Component({
  selector: 'fc-legal-page',
  templateUrl: './manage-legal-page.component.html',
  styleUrls: ['./manage-legal-page.component.scss'],
})
export class ManageLegalPageComponent extends AdminTableBase implements OnInit {
  destroyRef = inject(DestroyRef);
  displayedColumns: string[] = ['name', 'version'];

  readonly PAGE_NAME: string = 'legal-config';

  filterValues = {
    page_version: 'Current',
  };

  dataSource: MatTableDataSource<LegalPage>;

  // names of columns must match backend column names
  sortBy = {
    name: this.sortStates.untouched,
  };

  constructor(
    readonly router: Router,
    readonly store: Store<fromApp.AppState>,
    readonly legalService: LegalService,
  ) {
    super();
  }

  ngOnInit() {
    this.store
      .select(selectAdminFiltersAndPage)
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(state => {
        let pageFilter = super.setUpAdminFilter(state.filters);
        this.filterQuery = pageFilter?.filterQuery || `&page_version=Current`;
        this.initializeFilters();
        this.queryItems();
      });
  }

  queryItems(): void {
    this.legalService.getAllLegalPages('?' + this.sortQuery + this.filterQuery).subscribe(configResults => {
      this.dataSource = new MatTableDataSource(configResults.results);
      this.totalItems = configResults.total;
      this.setAllPages();
      this.setStartEndIndexes();
    });
  }

  clickRow(event: MouseEvent, row: LegalPage): void {
    this.router.navigate(['/admin/edit-legal-page', row.id]);
  }
}
